import { resendVerificationEmailReq } from "../../../redux/member-slices/auth.slice";
import { hideDialog } from "../../../redux/guest-slices/other.slice";
import { useDispatch, useSelector } from "react-redux";
import Icons from "../../../assets/js/Icons";

import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Icon,
  IconButton,
  Paper,
  Typography,
} from "@mui/material";

function CheckEmail() {
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state.otherSlice);

  // Close dialog
  const handleClose = () => {
    dispatch(hideDialog());
  };

  // Handle resend email
  const resendEmail = () => {
    // dispatch(resendVerificationEmailReq({ email: "bhupendra.canws@gmail.com" }))
    dispatch(resendVerificationEmailReq({ email: data?.email }));
  };

  return (
    <Paper>
      <DialogTitle sx={{ position: "relative" }}>
        <IconButton
          sx={{
            top: "10px",
            right: "10px",
            color: "black",
            position: "absolute",
            bgcolor: "#0000001f !important",
          }}
          size="small"
          onClick={handleClose}
        >
          <Icons.Cross />
        </IconButton>
      </DialogTitle>
      <DialogContent
        className="relative"
        sx={{
          ".MuiInputBase-root": { borderRadius: "6px" },
          textarea: { resize: "none" },
        }}
      >
        <Box sx={{ mb: 1, display: "grid", placeContent: "center" }}>
          <Icon
            sx={{
              fontSize: "100px",
              color: "primary.main",
              svg: { display: "block" },
            }}
          >
            <Icons.SentPlane />
          </Icon>
        </Box>
        <Typography fontSize={15} color="other.color1" textAlign="center">
          We&apos;ve sent a verification link to your email address. Please
          click the link to verify your account and complete the process.
        </Typography>
        <Typography
          mt={2}
          fontSize={14}
          color="other.color1"
          textAlign="center"
        >
          Didn&apos;t receive the email?
          <Button
            sx={{
              lineHeight: "1",
              fontSize: "14px",
              ":hover": {
                textDecoration: "underline",
              },
            }}
            disableRipple
            variant="text"
            color="primary"
            onClick={resendEmail}
          >
            Resend email
          </Button>
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center" }}>
        <Button
          color="primary"
          variant="contained"
          onClick={handleClose}
          sx={{
            minWidth: "150px",
            justifyContent: "center",
          }}
        >
          Okay
        </Button>
      </DialogActions>
    </Paper>
  );
}

export default CheckEmail;
